const translations = {
  en: {
    uploading: 'Uploading',
    uploadingItem: 'Uploading 1 item',
    uploadingItems: 'Uploading {quantity} items',
    upload: 'Upload',
    remove: 'Remove',
    download: 'Download',
    rename: 'Rename',
    creating: 'Creating',
    creatingName: 'Creating {name}...',
    create: 'Create',
    createFolder: 'Create folder',
    previewFile: 'Preview file',
    zipping: 'Zipping',
    zippingItem: 'Zipping 1 item',
    zippingItems: 'Zipping {quantity} items',
    items: 'items',
    item: 'item',
    cancel: 'Cancel',
    confirm: 'Confirm',
    folderName: 'Folder name',
    files: 'files',
    fileExist: 'File or folder with name {name} already exists',
    newName: 'New name',
    emptyName: "Name can't be empty",
    tooLongFolderName: "Folder name can't contain more than 255 characters",
    folderNameNotAllowedCharacters: 'Folder name contains not allowed characters',
    title: 'Title',
    fileSize: 'Size',
    description: 'Description',
    uploader: 'Uploader',
    createDate: 'Created',
    changeDate: 'Last modified',
    reallyRemove: '{files} will be deleted. Do you really want to proceed?',
    unableReadDir: 'Unable to read a directory.',
    descriptionEdit: 'Edit description',
    markAsInsuredVisible: 'Mark as Insured visible',
    unmarkAsInsuredVisible: 'Unmark as Insured visible',
    insuredVisible: 'Insured visible',
    newDescription: 'New description',
    save: 'Save',
    moveTo: 'Move to',
    moveHere: 'Move here',
    move: 'Move',
    copyTo: 'Copy to',
    copyHere: 'Copy here',
    search: 'Search files',
    send: 'Send',
    sendHeader: 'Send Files',
    sendConfirm: 'Send File',
    selectOneDriveRootFolder: 'Assign root folder for OneDrive',
    resetOneDriveRootFolder: 'Reset root folder for OneDrive',
    loginOneDrive: 'Login OneDrive',
    logoutOneDrive: 'Logout OneDrive',
    selectGoogleDriveRootFolder: 'Assign root folder for Google Drive',
    resetGoogleDriveRootFolder: 'Reset root folder for Google Drive',
    loginGoogleDrive: 'Login Google Drive',
    uploadFolder: 'Upload folder',
    createNote: 'Create Note',
    createTask: 'Create Task',
    createServiceRequest: 'Create Service Request',
  },
};

export default function getMessage(locale, key, params) {
  const translationExists = translations[locale] && translations[locale][key];
  const translation = translationExists ? translations[locale][key] : translations['en'][key];
  if (!params) {
    return translation;
  }

  const re = /{\w+}/g;
  function replace(match) {
    const replacement = match.slice(1, -1);
    return params[replacement] ? params[replacement] : '';
  }

  return translation.replace(re, replace);
}
